<template>
  <div class="container mt-5">
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button"
          role="tab" aria-controls="home-tab-pane" aria-selected="true">คำนวณยอดผ่อนต่อเดือน</button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button"
          role="tab" aria-controls="profile-tab-pane" aria-selected="false">คำนวณวงเงินที่สามารถกู้ได้</button>
      </li>
    </ul>
    <div class="tab-content" id="myTabContent">
      <!-- Tab 1: คำนวณยอดผ่อนต่อเดือน -->
      <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabindex="0">
        <CalculateMonthly />
      </div>
      <!-- Tab 2: คำนวณวงเงินที่สามารถกู้ได้ -->
      <div class="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabindex="0">
        คำนวณวงเงินที่สามารถกู้ได้
      </div>
    </div>
  </div>
</template>


<script>
import CalculateMonthly from '@/components/CalculateMonthly.vue';

export default {
  name: 'CalculateMonthly',
  components: {
    CalculateMonthly
  },
}
</script>


